/**
 * Get the next step id
 *
 * @param {string} newStepId - current step id
 * @returns {string} - next step id
 */
export function getNextStepId(newStepId) {
	return document.querySelector(`#${newStepId}`).nextElementSibling.getAttribute('id');
}
